<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="elevation-5 mb-0" style="z-index: 1">
      <v-btn icon :to="projects">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$route.params.project_id">{{ form.name }}</v-toolbar-title>
      <v-toolbar-title v-else>New project</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="my-0" color="success" @click="save">save</v-btn>
    </v-toolbar>
    <progress-bar></progress-bar>
    <v-tabs class="elevation-1 mb-3" color="info" v-model="tabs" dark grow slider-color="#fff">
      <v-tab ripple>Main info</v-tab>
      <v-tab ripple>Labels</v-tab>
    </v-tabs>
    <v-tabs-items :touchless="true" v-model="tabs" class="transparent elevation-0">
      <v-tab-item>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-card>
              <v-card-text>
                <div class='sl_form_title'>
                  <h3>Information</h3>
                </div>
                <v-divider class='my-2'></v-divider>
                <v-text-field v-model="form.name" :error-messages="errorMessages('name')"
                              label="Title"></v-text-field>
                <v-text-field v-model="form.short_name" :error-messages="errorMessages('short_name')"
                              label="Code"></v-text-field>
                <v-select
                  label="Instance"
                  :items="user.instanceUsers"
                  item-text="instance.name"
                  item-value="id"
                  v-model="form.instance_user_id"
                />
                <div>
                  <h4>References</h4>
                  <ul v-if="form.links && form.links.length">
                    <li v-for="(link, index) in form.links">
                      <a :href="link.url" target="_blank">
                        <span>{{ link.name }}</span>
                        <v-btn @click.stop.prevent="editLink(link)" class="my-0 mr-0" icon small>
                          <v-icon color="info" size="14">edit</v-icon>
                        </v-btn>
                        <v-btn @click.stop.prevent="remove('links', index)" class="my-0 mx-0" icon small>
                          <v-icon size="14" color="error">close</v-icon>
                        </v-btn>
                      </a>
                    </li>
                  </ul>
                  <ul class="project_links__list">
                    <li>
                      <v-text-field :error="linksError" v-model="link.name" hide-details
                                    label="Reference Text"></v-text-field>
                      <v-text-field hint="To be specified together with 'https://' or 'http://'" persistent-hint
                                    :error="linksError" v-model="link.url" label="Reference address"></v-text-field>
                    </li>
                  </ul>
                  <v-btn block small color="info" mx-0 my-2 @click="addLink">Add reference</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4>
            <v-card>
              <v-card-text>
                <div class='sl_form_title'>
                  <h3>Columns</h3>
                </div>
                <v-divider class='my-2'></v-divider>
                <sl-extended-select v-model="form.columns" :data="columns" :withOptions="false"></sl-extended-select>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4>
            <v-card>
              <v-card-text>
                <div class='sl_form_title'>
                  <h3>Participants</h3>
                </div>
                <v-divider class='my-2'></v-divider>
                <sl-extended-select v-model="form.instance_users" :data="instance_users" :withOptions="true"></sl-extended-select>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-card-text>
            <project-labels></project-labels>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins'

  import labels from '@/components/projects/labels'
  import users from '@/components/sl-extended-select'
  import {mapGetters} from "vuex";

  export default {
    name: 'ProjectsFormPage',
    mixins: [mixins.errors, mixins.form, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.projects,
        tabs: null,
        columns: [],
        selections: [],
        instance_users: [],
        form: {
          name: '',
          id: 0,
          instance_user_id: 0,
          short_name: '',
          instance_user: {},
          instance_users: [],
          links: [],
          columns: [],
        },
        link: {
          name: '',
          url: ''
        },
        linksError: false
      }
    },
    computed: mapGetters(["projects"]),
    methods: {
      getColumns() {
        setTimeout(() => {
          let params = {
            unlimit: 1
          }
          return this.$api.columns.list(params).then(response => {
            this.columns = response.data
          })
        }, 500)
      },
      remove(key, index) {
        this.form[key].splice(index, 1)
      },
      refreshTable() {
        this.$refs.list.refresh()
      },
      addLink() {
        if (this.link.name && this.link.url) {
          this.form.links.push(this.link)
          this.link = {name: '', url: ''}
          this.linksError = false
        } else {
          this.linksError = true
        }
      },
      editLink(link) {
        this.link = link
      }
    },
    mounted() {
      if (this.$route.params.project_id > 0) {
        this.load(this.$route.params.project_id)
      }

      this.$api.instance_users.list({unlimit: 1}).then(({data}) => {
        this.instance_users = data
      })

      this.form.instance_user_id = this.user.instanceUserIds[0]

      this.background(this.getColumns())
    },
    components: {
      'sl-extended-select': users,
      'project-labels': labels,
    }
  }
</script>
